
export enum unitBaseTypeEnum {
    C_L = "C-L",
    C_M = "C-M",
    C_S = "C-S",
    C_XL = "C-XL",
    C_XS = "C-XS",
    G_L = "G-L",
    G_M = "G-M",
    // G_XS = "G-XS",
    G_S = "G-S",
    G_XL = "G-XL",
    H_L = "H-L",
    H_M = "H-M",
    H_S = "H-S"
};